import React, { useState } from 'react';

import { useToggle } from 'utils/hooks/useToggle';
import { useEvieHomeContext } from '../EvieHomeProvider';
import { useCompleteSessionActivity } from '../Service/useCompleteSessionActivity';
import { HOME_STATUS, getSqueezeDuration } from '../utils';

import SqueezeHeader from '../SqueezeHeader';
import SqueezeAnimation from '../SqueezeAnimation';
import SqueezeAudio from '../SqueezeAudio';
import SqueezeControls from '../SqueezeControls';
import LeaveSessionModal from '../LeaveSessionModal';
import CompleteSessionActivityModal from '../CompleteSessionActivityModal';

const SqueezeView = () => {
  const {
    changeHomeStatus,
    selectTask,
    selectedTask: { squeezes = [] },
  } = useEvieHomeContext();
  const { completeSession, onCompleteSession, sessionCompleted } = useCompleteSessionActivity({
    endAction: () => changeHomeStatus(HOME_STATUS.IDLE),
  });

  const [currentSqueezeNumber, setCurrentSqueezeNumber] = useState(1);
  const [isPlaying, setIsPlaying] = useToggle(true);
  const [isMuted, setIsMuted] = useToggle();
  const [displayAlert, setDisplayAlert] = useToggle();

  const currentSqueeze = squeezes.find(({ position }) => position === currentSqueezeNumber) || {};
  const { squeeze: { title = '', jsonParse = '', audio = '', content = [] } = {} } = currentSqueeze;
  const duration = getSqueezeDuration(squeezes);

  return (
    <>
      <section className="squeeze-view">
        <SqueezeHeader
          title={title}
          duration={duration}
          isPlaying={isPlaying}
          setDisplayAlert={setDisplayAlert}
          setIsPlaying={setIsPlaying}
          endSqueeze={onCompleteSession}
        />
        <section className="squeeze-view__squeeze">
          <SqueezeAnimation key={currentSqueezeNumber + 1} json={jsonParse} isPlaying={isPlaying} />
          <SqueezeAudio key={currentSqueezeNumber + 2} audioSrc={audio} isPlaying={isPlaying} isMuted={isMuted} />
        </section>
        <SqueezeControls
          key={currentSqueezeNumber + 3}
          isPlaying={isPlaying}
          isMuted={isMuted}
          content={content}
          setIsMuted={setIsMuted}
          setIsPlaying={setIsPlaying}
          goNextSqueeze={setCurrentSqueezeNumber}
        />
      </section>
      {displayAlert && (
        <LeaveSessionModal
          modalIsOpen={displayAlert}
          toggleModal={setDisplayAlert}
          selectContent={selectTask}
          changeViewStatus={() => changeHomeStatus(HOME_STATUS.IDLE)}
        />
      )}
      {sessionCompleted && (
        <CompleteSessionActivityModal
          modalIsOpen={sessionCompleted}
          toggleModal={onCompleteSession}
          completeSession={completeSession}
        />
      )}
    </>
  );
};

export default SqueezeView;
